/* ShopDoorMate "Find your mat" quiz. Client-side only: no data is stored or sent anywhere. */
(function () {
  // Design traits per mat (from the artwork). Mats not listed here are matched by vibe only.
  var TRAITS = {
    'fine-dining-doormat':        { c: ['dark'],           h: ['witty'] },
    'the-butler-doormat':         { c: ['dark'],           h: ['witty', 'sassy'] },
    'rich-in-taste-doormat':      { c: ['dark'],           h: ['witty'] },
    'hungry-human-doormat':       { c: ['bright'],         h: ['sassy'] },
    'not-the-food-doormat':       { c: ['bright'],         h: ['sassy'] },
    'ring-twice-doormat':         { c: ['dark', 'bright'], h: ['witty', 'sweet'] },
    'food-goes-here-round-doormat': { c: ['bright'],       h: ['sweet', 'simple'] },
    'too-cute-to-cook-doormat':   { c: ['pink'],           h: ['sassy'] },
    'good-vibes-doormat':         { c: ['pink'],           h: ['sweet'] },
    'queen-of-takeout-doormat':   { c: ['pink'],           h: ['sassy'] },
    'looking-cute-doormat':       { c: ['pink'],           h: ['witty', 'sassy'] },
    'supply-drop-doormat':        { c: ['earthy'],         h: ['witty'] },
    'man-cave-fuel-doormat':      { c: ['dark'],           h: ['witty'] },
    'ordered-wings-doormat':      { c: ['earthy'],         h: ['witty'] },
    'energy-saving-mode-doormat': { c: ['dark'],           h: ['sassy', 'witty'] },
    'crummy-cookie-doormat':      { c: ['bright'],         h: ['witty', 'sweet'] },
    'drop-food-here-doormat':     { c: ['earthy'],         h: ['sweet', 'simple'] },
    'deliveries-doormat':         { c: ['dark'],           h: ['simple'] }
  };
  var TITLES = {
    'luxury': '👑 You\'re a Fancy Feaster',
    'super-girly': '💖 You\'re Takeout Royalty',
    'manly': '🔥 You\'re the Grill Sergeant',
    'cheerful-funny': '😂 You\'re the Snack Comedian',
    'kids': '🍪 You\'re the Little Snack Boss',
    'classic': '✅ You\'re a No-Fuss Foodie'
  };
  var ORDER = ['vibe', 'color', 'humor'];

  function esc(s) { return String(s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }

  function score(m, a) {
    var t = TRAITS[m.h] || { c: [], h: [] };
    var s = 0;
    if (m.v === a.vibe) s += 6;
    if (t.c.indexOf(a.color) > -1) s += 3;
    if (t.h.indexOf(a.humor) > -1) s += 2;
    return s;
  }

  function pick(mats, a) {
    var ranked = mats.map(function (m, i) { return { m: m, s: score(m, a), i: i }; })
      .sort(function (x, y) { return y.s - x.s || x.i - y.i; });
    var out = [], vibesUsed = {};
    // first: best matches; let at most 2 non-vibe mats come from the same other vibe for variety
    for (var k = 0; k < ranked.length && out.length < 3; k++) {
      var r = ranked[k];
      if (r.m.v !== a.vibe) {
        if (vibesUsed[r.m.v]) continue;
        vibesUsed[r.m.v] = true;
      }
      out.push(r.m);
    }
    for (var j = 0; j < ranked.length && out.length < 3; j++) { if (out.indexOf(ranked[j].m) < 0) out.push(ranked[j].m); }
    return out;
  }

  function card(m) {
    return '<li class="sdm-card">' +
      '<a class="sdm-card__media" href="' + esc(m.u) + '" tabindex="-1" aria-hidden="true">' +
        (m.img ? '<img class="sdm-card__img" src="' + esc(m.img) + '" alt="" width="640" height="360" loading="lazy">' : '') +
        '<span class="sdm-card__tag">' + esc(m.e) + ' ' + esc(m.vt) + '</span></a>' +
      '<div class="sdm-card__body"><a class="sdm-card__name" href="' + esc(m.u) + '">' + esc(m.t) + '</a>' +
        '<span class="sdm-card__price">' + esc(m.p) + '</span>' +
        '<span class="sdm-card__actions"><a class="sdm-card__view" href="' + esc(m.u) + '">View mat</a>' +
        '<a class="sdm-card__porch" href="' + esc(m.porch) + '">📸 On my porch</a></span></div></li>';
  }

  function boot(root) {
    if (root.__sdmQuiz) return; root.__sdmQuiz = true;
    var wrap = root.closest('.sdm-quiz-wrap') || document;
    var dataEl = wrap.querySelector('[data-quiz-mats]');
    var mats = [];
    try { mats = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var qs = root.querySelectorAll('[data-q]');
    var bar = root.querySelector('[data-quiz-bar]');
    var stepEl = root.querySelector('[data-quiz-step]');
    var result = root.querySelector('[data-quiz-result]');
    var back = root.querySelector('[data-quiz-back]');
    var answers = {}, step = 0;

    function show(i) {
      step = i;
      qs.forEach(function (q, n) { q.hidden = n !== i; q.classList.toggle('is-active', n === i); });
      result.hidden = i < ORDER.length;
      back.hidden = i === 0;
      bar.style.width = (Math.min(i, ORDER.length) / ORDER.length * 100) + '%';
      stepEl.textContent = i < ORDER.length ? 'Question ' + (i + 1) + ' of ' + ORDER.length : 'Your matches are in!';
      root.classList.toggle('is-done', i >= ORDER.length);
    }
    function finish() {
      var picks = pick(mats, answers);
      root.querySelector('[data-quiz-title]').textContent = TITLES[answers.vibe] || 'Your perfect mats';
      root.querySelector('[data-quiz-picks]').innerHTML = picks.map(card).join('');
      show(ORDER.length);
      result.focus({ preventScroll: true });
      var top = root.getBoundingClientRect().top + window.scrollY - 90;
      if (root.getBoundingClientRect().top < 0) window.scrollTo({ top: top, behavior: 'smooth' });
    }
    qs.forEach(function (q, n) {
      q.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-a]'); if (!b) return;
        answers[q.getAttribute('data-q')] = b.getAttribute('data-a');
        q.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        if (n + 1 < ORDER.length) { show(n + 1); var nb = qs[n + 1].querySelector('button'); if (nb) nb.focus({ preventScroll: true }); }
        else finish();
      });
    });
    back.addEventListener('click', function () { show(Math.max(0, Math.min(step, ORDER.length) - 1)); });
    root.querySelector('[data-quiz-restart]').addEventListener('click', function () { answers = {}; show(0); });
    root.__sdmPick = function (a) { return pick(mats, a).map(function (m) { return m.h; }); };
    show(0);
  }
  function init() { document.querySelectorAll('[data-sdm-quiz]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
